<h3>{{ 'bcs.sectionTitle' | transloco }}</h3>

<div class="flex items-center mb-4">
  <span>{{ 'bcs.showInfoGrafik' | transloco }}</span>

  <button
    type="button"
    pButton
    icon="pi pi-window-maximize"
    class="p-button-text p-button-sm"
    (click)="openMediaDialog()"
  ></button>
</div>

<div class="grid grid-cols-12 gap-4">
  <!-- Pflegezustand -->
  <div class="col-span-12" [ngClass]="temperamentCtrl ? 'md:col-span-4' : 'md:col-span-6'">
    <p-iftalabel>
      <label>
        {{ 'bcs.care.title' | transloco }}
      </label>
      <p-multiSelect
        [options]="careOptions"
        [overlayOptions]="dropdownOverlayOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="careCtrl.value"
        (onChange)="
        careCtrl.setValue($event.value);
        careCtrl.markAsDirty();
        careCtrl.markAsTouched()
      "
        [styleClass]="(careInvalid ? 'ms-invalid ' : '') + 'w-full'"
      >
        <!-- Dropdown-Einträge mit Übersetzung -->
        <ng-template pTemplate="item" let-opt>
          <div class="flex flex-col">
            <span>{{ opt.label | transloco }}</span>
            <small class="text-xs text-gray-500">
              {{ opt.description | transloco }}
            </small>
          </div>
        </ng-template>

        <!-- Ausgewählte Items im Input -->
        <ng-template pTemplate="selectedItems" let-selected>
          @if (selected?.length) {
            @for (opt of selected; track opt; let i =
                $index) {
              {{ opt.label | transloco }}
              @if (i < selected.length - 1) {
                ,
              }
            }
          }
        </ng-template>
      </p-multiSelect>
    </p-iftalabel>
    <div class="mt-2 flex flex-wrap gap-2">
      @for (item of selectedCare; track item) {
        <p-chip [label]="getCareDescription(item) | transloco"></p-chip>
      }
    </div>
  </div>

  <!-- Ernährungszustand -->
  <div class="col-span-12" [ngClass]="temperamentCtrl ? 'md:col-span-4' : 'md:col-span-6'">
    <p-iftalabel>
      <label>
        {{ 'bcs.nutrition.title' | transloco }}
      </label>
      <p-select
        [options]="nutritionOptions"
        [overlayOptions]="dropdownOverlayOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="nutritionCtrl.value ?? null"
        (ngModelChange)="
        nutritionCtrl.setValue($event ?? null);
        nutritionCtrl.markAsDirty();
        nutritionCtrl.markAsTouched()
      "
        [styleClass]="(nutritionInvalid ? 'ms-invalid ' : '') + 'w-full'"
      >
        <ng-template pTemplate="item" let-opt>
          <div class="flex flex-col">
            <span>{{ opt.label | transloco }}</span>
            <small class="text-xs text-gray-500">
              {{ opt.description | transloco }}
            </small>
          </div>
        </ng-template>

        <ng-template pTemplate="selectedItem" let-opt>
          @if (opt) {
            {{ opt.label | transloco }}
          }
        </ng-template>
      </p-select>
    </p-iftalabel>
  </div>

  <!-- Wesen -->
  @if (temperamentCtrl) {
  <div class="col-span-12 md:col-span-4">
    <p-iftalabel>
      <label>
        {{ 'bcs.temper.title' | transloco }}
      </label>
      <p-multiSelect
        [options]="temperamentOptions"
        [overlayOptions]="dropdownOverlayOptions"
        optionLabel="label"
        optionValue="value"
        [ngModel]="temperamentCtrl.value"
        (onChange)="
          temperamentCtrl.setValue($event.value);
          temperamentCtrl.markAsDirty();
          temperamentCtrl.markAsTouched()
        "
        [styleClass]="(temperamentInvalid ? 'ms-invalid ' : '') + 'w-full'"
      >
        <ng-template pTemplate="item" let-opt>
          <div class="flex flex-col">
            <span>{{ opt.label | transloco }}</span>
            <small class="text-xs text-gray-500">
              {{ opt.description | transloco }}
            </small>
          </div>
        </ng-template>

        <ng-template pTemplate="selectedItems" let-selected>
          @if (selected?.length) {
            @for (opt of selected; track opt; let i =
                $index) {
              {{ opt.label | transloco }}
              @if (i < selected.length - 1) {
                ,
              }
            }
          }
        </ng-template>
      </p-multiSelect>
    </p-iftalabel>

    <div class="mt-2 flex flex-wrap gap-2">
      @for (item of selectedTemperament; track item) {
        <p-chip [label]="getTemperamentDescription(item) | transloco"></p-chip>
      }
    </div>
  </div>
  }
</div>

<p-dialog
  [(visible)]="mediaDialogVisible"
  [modal]="true"
  [closable]="true"
  [maximizable]="true"
  [dismissableMask]="true"
  [style]="{ width: '80vw', height: '80vh' }"
  (onHide)="closeMediaDialog()"
>
  <ng-template pTemplate="header">
    {{ 'bcs.sectionTitle' | transloco }}
  </ng-template>

  <ng-template pTemplate="content">
    <div class="w-full h-full flex items-center justify-center">
      <img
        src="assets/images/body-condition-score-infografik.png"
        alt="Body Condition Score"
        class="max-w-full max-h-full object-contain"
      />
    </div>
  </ng-template>
</p-dialog>
